import { render } from "./SimpleSelector.vue?vue&type=template&id=ea72d27a&scoped=true&ts=true"
import script from "./SimpleSelector.vue?vue&type=script&lang=ts"
export * from "./SimpleSelector.vue?vue&type=script&lang=ts"

import "./SimpleSelector.vue?vue&type=style&index=0&id=ea72d27a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea72d27a"]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QInfiniteScroll});
